module.exports = __webpack_public_path__ + "media/images/flags/NE-0ef16def1d7662e5b39925f3393c4fc9.svg";